import { FinancialReview } from './financialReview.model';
import { MasterMatrix } from '@models/mastermatrix.model';

export class SubsetModel {
  bdMatrixSubsetId: number;
  studySearchStrategyId: number;
  subsetName: string;
  sectionType: number;
  comparableIds: number[];
  financialComparables: FinancialReview[];
  masterMatrixComparables: MasterMatrix[];
  isActive: boolean;
  createdBy: number;
  createdOn: Date;
}
